<template>
  <div id="add-contact-l2">
    <section class="toggle-header">
      <personal-info-vue :birthday-needed="false" />
      <!-- Phones -->
      <phone-vue />
      <!-- Email -->
      <email-vue />
      <timezone-vue />
      <div class="btn-wrapper full-width float-left">
        <a
          href="#"
          class="btn-toggle-sumbit buttonstyle"
          @click.prevent="showPopupLocal"
          >Add Person</a
        >
        <a
          href="#"
          class="btn-toggle-sumbit buttonstyle"
          @click.prevent="hideDropDown"
          >Cancel</a
        >
      </div>
      <!-- Popup -->
    </section>
    <div class="popup" v-show="showPopup">
      <transition name="pop">
        <popup-vue
          v-if="showPopup"
          :hide="hideThePopup"
          :additional-function="hideDropDown"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { addNewHomeMixin } from "../../../../mixins/addNewHomeMixin";
import { addPersonMixin } from "../../../../mixins/addPersonMixin";
import PopupVue from "../../../Person/AddPerson/Popup";
import PersonalInfoVue from "../../../common/AddNew/PersonalInfo";
import PhoneVue from "../../../common/AddNew/Phone";
import EmailVue from "../../../common/AddNew/Email";
import TimezoneVue from "../../../common/AddNew/Timezone";

export default {
  mixins: [addNewHomeMixin, addPersonMixin],
  components: {
    PersonalInfoVue,
    PhoneVue,
    EmailVue,
    TimezoneVue,
    PopupVue
  },
  props: {
    hideDropDown: Function
  },
  computed: {
    ...mapGetters("person", {
      validated: "getValidated"
    })
  },
  methods: {
    ...mapMutations("person", {
      setValidated: "setValidated"
    }),
    ...mapActions("person", {
      validate: "validate"
    }),
    showPopupLocal() {
      this.validate();
    }
  },
  watch: {
    validated(value) {
      if (value) {
        this.showThePopup();
      }
    }
  }
  // destroyed() {
  //   this.clearState();
  // }
};
</script>

<style scoped>
.popup {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

/* stage 2. Entered */
.pop-enter-active {
  animation: pop-in 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.pop-leave-active {
  animation: pop-out 0.2s ease-in-out forwards;
}

@keyframes pop-in {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pop-out {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
}
</style>
